import { Button, Dialog, DialogActions, Stack } from "@mui/material";
import ImageUploadHandler from "components/PimDashboard/CommonComponents/ImageUploadHandler/ImageUploadHandler";
import { isMainImg } from "../../CreateModalProfile/AddImagesModal/AddImagesModal";
import { useState } from "react";

const AddNewImageModal = ({ modalOpen, setModalOpen, submitFunction, defaultImages }) => {
	const [newImages, setNewImages] = useState(defaultImages?.length ? defaultImages : []);
	const [mainImageIndex, setMainImageIndex] = useState(0);

	const handleCloseModal = () => {
		setModalOpen(false);
	};
	const handleFormSubmit = async (e) => {
		e.preventDefault();

		if (typeof submitFunction === "function") {
			const updatedFormat = newImages.map((row, i) => {
				return {
					file: row.file,
					url: row.url,
					[isMainImg]: mainImageIndex === i,
				};
			});
			console.log(updatedFormat);
			let result = await submitFunction(updatedFormat);
			if (result) {
				setModalOpen(false);
				setNewImages([]);
			}
		}
	};
	return (
		<Dialog fullWidth maxWidth="md" open={modalOpen} onClose={handleCloseModal} component="form" onSubmit={handleFormSubmit}>
			<Stack>
				<ImageUploadHandler
					images={newImages}
					setImages={setNewImages}
					mainImageIndex={mainImageIndex}
					setMainImageIndex={setMainImageIndex}
					disableButtons={false}
				/>
			</Stack>

			<DialogActions>
				<Button variant="outlined" onClick={handleCloseModal}>
					Cancel
				</Button>
				<Button autoFocus variant="contained" sx={{ mr: 1 }} type="submit">
					Save
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default AddNewImageModal;
